const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
// OBS: These values are in cents

const DISCOUNT_2 = 1400;
const DISCOUNT_3 = 2800;
const DISCOUNT_4 = 5800;
const PRODUCT_WINES_TITLES = ["French Red", "French Rosé", "Italian White"];
const MAX_WINES_LIMIT = 4;

const MAP_SELLING_PLAN_ID = {
  // 30D
  1294860348: [1253474364, 1253572668, 1253605436],
  // 60D
  1294827580: [1253507132, 1253539900, 1253638204],
  // 90D
  1294794812: [1296957500, 1296990268, 1297023036],
};

document.addEventListener("DOMContentLoaded", function () {
  const pickers = document.querySelectorAll(".picker");
  const quantityBtns = document.querySelectorAll("[btn-quantity]");
  const purchaseOptions = document.querySelectorAll(".purchase-option");
  const btnPurchase = document.querySelector(".btn-purchase button");

  setTimeout(() => {
    document.querySelector('[data-input-quantity]')
    .value = 1;
    document.querySelector('[data-input-quantity]')
    .dispatchEvent(new Event('change'))
  }, 0);
  

  document.querySelectorAll('.picker[data-out-of-stock="true"]').forEach(function(picker) {
    picker.style['border-color'] = '#616161';
    picker.style.opacity = '0.5';
    picker.querySelectorAll('input, button').forEach(function(el) {
      el.value = 0;
      el.setAttribute('disabled', 'disabled');
    });
  });
  

  purchaseOptions.forEach((option) => {
    option.querySelector("input").addEventListener("change", function () {
      const purchaseType = getPurchaseTypeSelected();
      const text =
        purchaseType === "one-time" ? "Add to cart" : "Subscribe and Save";
      btnPurchase.querySelector("span.text").textContent = text;

      if (purchaseType === "one-time") {
        document.querySelector(".frequency-selector").classList.add("d-none");
      } else {
        document
          .querySelector(".frequency-selector")
          .classList.remove("d-none");
      }

      const cancelAnytime = document.querySelector(".cancel-anytime");
      if (purchaseType === "one-time") {
        cancelAnytime.classList.remove("active");
      } else {
        cancelAnytime.classList.add("active");
      }
    });
  });

  quantityBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = btn.parentElement.querySelector("[data-input-quantity]");
      const value = parseInt(input.value);

      if (btn.dataset.type === "minus") {
        if (value > 0) {
          input.value = value - 1;
        }
      } else {
        input.value = value + 1;
      }

      input.dispatchEvent(new Event("change"));
    });
  });

  btnPurchase.addEventListener("click", async function () {
    // limpar o carrinho
    const products = getProductsSelected();
    if (!products.length) return;

    const totalQuantity = products.reduce(
      (prev, curr) => prev + curr.quantity,
      0
    );

    const frequency = getSubscriptionFrequencySelected();
    const purchaseType = getPurchaseTypeSelected();
    btnPurchase.classList.add("loading");

    const currentCartItems = await getCurrentCartItems();

    if (
      totalQuantity + currentCartItems.totalWinesQuantity >
      MAX_WINES_LIMIT
    ) {
      document.querySelector(".limit-warn").classList.remove("d-none");
      btnPurchase.classList.remove("loading");
      return;
    } else {
      document.querySelector(".limit-warn").classList.add("d-none");
    }

    let body;

    if (purchaseType === "one-time" || totalQuantity < 2) {
      body = JSON.stringify({
        items: products.map((product) => {
          return {
            quantity: product.quantity,
            id: product.variantId,
          };
        }),
      });
    } else {
      const sellingPlanId = getSellingPlanId();
      const bundleProductData = {
        variantId: `${productBundleVariantId}`,
        productId: `${productBundleId}`,
        sellingPlan: Number(sellingPlanId), // Selling plan id (frequency  1, 2, 3, 4)
        handle: "medly-wine",
      };

      const bundle = {
        externalVariantId: bundleProductData.variantId,
        externalProductId: bundleProductData.productId,
        selections: products.map((product) => {
          let sellingPlan = product.sellingPlanIds.find(
            (productSellingPlanId) =>
              MAP_SELLING_PLAN_ID[sellingPlanId].includes(productSellingPlanId)
          );

          return {
            collectionId: "279920443452",
            sellingPlan: sellingPlan,
            externalProductId: `${product.productId}`,
            externalVariantId: `${product.variantId}`,
            quantity: product.quantity,
          };
        }),
      };

      // CUSTOM PRICE BUNDLE
      const cartItems = await recharge.bundle.getDynamicBundleItems(
        bundle,
        bundleProductData.handle
      );
      body = JSON.stringify({
        items: cartItems,
      });
    }

    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((res) => res.json())
      .then(async (data) => {
        updateCartCount();
        
        const cartDrawerBody = document.querySelector(
          '[data-section="ajax-cart"]'
        );
        await fetch("/?sections=ajax-cart")
          .then((res) => res.json())
          .then((res) => {
            cartDrawerBody.innerHTML = res["ajax-cart"];
            // contentLoad()
          })
          .then(() => {
            let cartItemRemoveElements = document.querySelectorAll(
              "[data-cart-item-remove]"
            );
            Array.from(cartItemRemoveElements).forEach(function (element) {
              initCartItemRemove(element);
            });
            return openDrawerCart();
          });
      })
      .finally(() => btnPurchase.classList.remove("loading"));
  });

  async function getCurrentCartItems() {
    const currentCartItems = [];
    const cartRes = await fetch(`/cart.js`);
    if (!cartRes.ok) {
      return [];
    }

    const cart = await cartRes.json();
    const items = cart.items;

    for (const item of items) {
      currentCartItems.push({
        variantId: item.variant_id,
        quantity: item.quantity,
        lineItemKey: item.key,
        maximumQuantityReachedOut: item.quantity >= MAX_WINES_LIMIT,
        isSubscription: item.selling_plan_allocation !== undefined,
        isWine: PRODUCT_WINES_TITLES.includes(item.product_title),
      });
    }

    return {
      items: currentCartItems,
      totalWinesQuantity: currentCartItems
        .filter((i) => i.isWine)
        .map((i) => i.quantity)
        .reduce((a, b) => a + b, 0),
    };
  }

  pickers.forEach((picker) => {
    const input = picker.querySelector("[data-input-quantity]");
    const inputs = document.querySelectorAll(
      ".picker input[data-input-quantity]"
    );
    input.addEventListener("change", function () {
      const calculateSubtotalOtherInputs = Array.from(inputs).reduce(
        (prev, curr) => {
          return prev < 4 ? prev + +curr.value : 4;
        },
        0
      );

      if (this.value < 0 || isNaN(this.value) || !this.value) {
        this.value = 0;
      }

      const otherInputsSum = Array.from(inputs).reduce((prev, curr) => {
        if (curr !== this) {
          return prev + (+curr.value || 0);
        }
        return prev;
      }, 0);

      const maxAllowed = 4 - otherInputsSum;

      if (+this.value > maxAllowed) {
        this.value = maxAllowed;
      }
      let total = Array.from(inputs).reduce(
        (prev, curr) => prev + (+curr.value || 0),
        0
      );
      while (total > 4) {
        let excess = total - 4;
        if (this.value >= excess) {
          this.value -= excess;
          total -= excess;
        } else {
          excess -= this.value;
          this.value = 0;
          total -= this.value;
        }
      }

      // Atualiza os outros inputs caso seja necessário ajustar valores
      Array.from(inputs).forEach((input) => {
        if (+input.value < 0 || isNaN(input.value) || !input.value) {
          input.value = 0;
        }
      });

      if (total < 2) {
        document
          .querySelector(".purchase-option.subscribe")
          .classList.add("d-none");
        document.querySelector('input[data-purchase-type="one-time"]').click();
        document
          .querySelector("[data-subtotal-subscription]")
          .classList.add("hide");
        document
          .querySelector("[data-subtotal-one-time]")
          .classList.add("hide");
        document
          .querySelector("#purchase-subscribe")
          .parentElement.parentElement.classList.add("hide");
      }
      if (total >= 2) {
        document
          .querySelector(".purchase-option.subscribe")
          .classList.remove("d-none");
        document
          .querySelector("[data-subtotal-one-time]")
          .classList.remove("hide");
        document
          .querySelector("[data-subtotal-subscription]")
          .classList.remove("hide");
        document
          .querySelector("#purchase-subscribe")
          .parentElement.parentElement.classList.remove("hide");
        
        if (total == 2) {
          document.querySelector('[data-purchase-type="subscribe"').click();
        }

      }

      const totalItens = getTotalPouches();
      const quantityPouches = document.getElementById("quantity-pouches");

      if (totalItens) {
        quantityPouches.classList.add("active");
      } else {
        quantityPouches.classList.remove("active");
      }

      document.querySelector("[total-pouch]").textContent = totalItens;
      document.querySelector("[multiplier-pouch]").textContent = totalItens * 4;
      const nextDiscount = getNextDiscountPercent();



      if (totalItens > 0 && nextDiscount > 0 && totalItens < 4) {
        const saveBanner = document.querySelector(".save-banner");
        saveBanner.classList.remove("d-none");
        saveBanner.querySelector(
          "[data-percent-save]"
        ).textContent = `${nextDiscount}%`;
      } else {
        document.querySelector(".save-banner").classList.add("d-none");
      }

      const totalValue = getTotal();
      const subTotalValue = getSubTotal();

      document.querySelector("[data-total-one-time]").textContent =
        formatter.format(totalValue.oneTimePurchase / 100);
      document.querySelector("[data-total-subscription]").textContent =
        formatter.format(totalValue.subscribe / 100);
      document.querySelector("[data-subtotal-one-time]").textContent =
        formatter.format(subTotalValue.oneTimePurchase / 100);
      document.querySelector("[data-subtotal-subscription]").textContent =
        formatter.format(subTotalValue.oneTimePurchase / 100);
    });
  });

  function openDrawerCart() {
    document.querySelector("[data-side-drawer-open]").click();
  }

  function getProductsSelected() {
    const pickers = document.querySelectorAll(".picker");
    const items = [];
    pickers.forEach((picker) => {
      const input = picker.querySelector("[data-input-quantity]");
      const sellingPlanIds = [];
      const quantity = parseInt(input.value);
      picker
        .querySelectorAll("[data-selling-plan-id]")
        .forEach((el) => sellingPlanIds.push(Number(el.value)));
      if (quantity > 0) {
        items.push({
          productId: Number(picker.dataset.productId),
          variantId: Number(picker.dataset.productVariantId),
          sellingPlanIds,
          quantity,
        });
      }
    });
    return items;
  }

  function getSubscriptionFrequencySelected() {
    const frequencySelector = document.querySelector(
      ".frequency-selector select"
    );
    return frequencySelector.value;
  }

  function getPurchaseTypeSelected() {
    const purchaseOptions = document.querySelector(
      ".purchase-option input:checked"
    );
    return purchaseOptions.dataset.purchaseType;
  }

  function getTotalPouches() {
    const pickers = document.querySelectorAll(".picker");
    let total = 0;
    pickers.forEach((picker) => {
      const input = picker.querySelector("[data-input-quantity]");
      total += parseInt(input.value);
    });

    return total;
  }

  function getNextDiscountPercent() {
    const totalPouches = getTotalPouches();
    const nextDiscount = calculateDiscount(totalPouches + 1);

    const nextSubTotal =
      getSubTotal().oneTimePurchase +
      parseFloat(
        document.querySelector("[data-product-price]").dataset.productPrice
      );
    const nextSubTotalWithDiscount = nextSubTotal - nextDiscount;

    const nextDiscountPercent = (
      ((nextSubTotal - nextSubTotalWithDiscount) / nextSubTotal) *
      100
    ).toFixed(2);

    return nextDiscountPercent;
  }

  function getSubTotal() {
    const totalDiscount = calculateDiscount();

    const pickers = document.querySelectorAll(".picker");
    let total = 0;
    let totalQuantity = 0;
    pickers.forEach((picker) => {
      const input = picker.querySelector("[data-input-quantity]");
      const quantity = parseInt(input.value);
      const price = parseFloat(
        picker.parentElement.querySelector("[data-product-price]").dataset
          .productPrice
      );
      totalQuantity += quantity;
      total += quantity * price;
    });

    return {
      oneTimePurchase: total,
      subscribe: total,
    };
  }

  function getTotal() {
    const totalQuantity = getTotalPouches();
    const totalDiscount = calculateDiscount();
    const totalOneTimePurchase = getSubTotal().oneTimePurchase;
    const totalDiscountSubscribe = calculateDiscountSubscribe(totalQuantity);
    
    return {
      oneTimePurchase: totalOneTimePurchase - totalDiscount,
      subscribe: totalOneTimePurchase - totalDiscountSubscribe,
    };
  }

  function getSellingPlanId() {
    const frequencySelector = document.querySelector(
      ".frequency-selector select"
    );
    return frequencySelector.value;
  }

  function calculateDiscount(totalPonchesDef) {
    const totalPouches = totalPonchesDef ?? getTotalPouches();
    let rest = totalPouches;
    let discount = 0;

    while (rest >= 2) {
      if (rest >= 4) {
        discount += DISCOUNT_4;
        rest -= 4;
        continue;
      }

      if (rest >= 3) {
        discount += DISCOUNT_3;
        rest -= 3;
        continue;
      }

      if (rest >= 2) {
        discount += DISCOUNT_2;
        rest -= 2;
        continue;
      }
    }

    return discount;
  }

  function calculateDiscountSubscribe(quantity) {
    switch (quantity) {
      case 1:
        return 0;
      case 2:
        return 2300;
      case 3:
        return 4300;
      case 4:
        return 7800;
      default:
        return 0;
    }
  }

  function updateCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((data) => {
        const quantity = data.items.reduce((prev, curr) => prev + curr.quantity, 0);
        cartCountUpdate(quantity);
      });
  }
});
